<template>
  <v-dialog v-model="open" width="450" persistent>
    <v-card class="event-form">
      <v-card-title class="p-3 mb-5" color="primary">
        <v-icon class="mr-3" @click="close">
          mdi-close
        </v-icon>
        {{ $t('PublishEventToWingDialog.PublishEvents') }}
      </v-card-title>
      <v-card-text>
        <p>{{ $t('PublishEventToWingDialog.SelectTimeframe') }}</p>
        <div class="d-flex justify-center align-cente">
          <v-date-picker ref="datePicker" :events="draftEventsDates" :event-color="getEventColor" full-width
            :locale="$i18n.locale" v-model="dates" range></v-date-picker>
        </div>
        <div class="mt-5">
          <v-checkbox
            v-model="isLifestyleEvent"
            :label="$t('PublishEventToWingDialog.LifestyleEvents')"
            @change="onChangeEvents"
          ></v-checkbox>

          <v-checkbox
            v-model="isConciergeEvent"
            :label="$t('PublishEventToWingDialog.ConciergeEvents')"
            @change="onChangeEvents"
          ></v-checkbox>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="publish" :loading="loading" :disabled="!dates">
          {{ $t('NewCalendarItem.Publish') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <ConfirmDlg ref="confirmationModal"></ConfirmDlg>
  </v-dialog>
</template>

<script>
import moment from "moment/moment";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import { getDraftEventsByTimeframe } from "@/utils/eventService";
import { EventsTypes } from "@/enums/EventsTypes";

export default {
  components: { ConfirmDlg },
  props: {
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dates: null,
      draftEvents: [],
      draftEventsDates: [],
      isLifestyleEvent: true,
      isConciergeEvent: false
    }
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    facility() {
      return this.$store.state.authModule.currentFacilityData
    }
  },

  watch: {
    async open(isOpen) {
      if (isOpen) {
        this.draftEventsDates = await this.getDraftEventsDates()
        //subscribe on v-date-picker month change
        this.$nextTick(() => {
          const table = this.$refs.datePicker.$refs.table;
          this.$watch(() => table.tableDate, this.handleMonthChange);
        });
      }
    }
  },


  methods: {
    async publish() {
      const sortedDates = this.sortDates(this.dates);
      const startDate = moment(sortedDates[0]).format(this.facility.dateFormat);
      const endDate = sortedDates[1] ? moment(sortedDates[1]).format(this.facility.dateFormat) : null;
      const selectedDraftEventsDates = await this.getDraftEventsDates([startDate, endDate])

      if (selectedDraftEventsDates.length > 0) {
        const text = `
        ${this.$t('PublishEventsByPeriodDialog.AreYouSureYouWantToPublishEventsFromTheSelectedTimeFrame', { count: selectedDraftEventsDates.length })}
        <br/>
        ${startDate}${endDate ? (' - ' + endDate) : ''}`;

        this.$refs.confirmationModal
          .open(null, text, false)
          .then(async (response) => {
            if (response && response.agree) {
              this.loading = true
              await this.$store.dispatch("publishEvents", sortedDates)
              this.close()
            } else {
              const startDate = moment(this.dates[0]).startOf('month');
              const endDate = moment(this.dates[0]).endOf('month');
              this.draftEventsDates = await this.getDraftEventsDates([startDate, endDate])
            }
          });
      }
      else {
        const text = this.$t('PublishEventsByPeriodDialog.NoEventsToPublish')

        this.$refs.confirmationModal.open(null, text, false, '', { noconfirm: true, yesButtonText: this.$t('GeneralTranslations.Ok') })
      }
    },
    async handleMonthChange(yearMonth) {
      const startDate = moment(yearMonth + '-01')
      const endDate = moment({ ...startDate }).endOf('month')

      this.draftEventsDates = await this.getDraftEventsDates([startDate, endDate])
    },
    async getDraftEventsDates(range) {
      if (!range) {
        range = [moment().startOf('month'), moment().endOf('month')]
      }
      this.draftEvents = (await getDraftEventsByTimeframe(this.facility.id, range))

      this.draftEvents = this.draftEvents.filter((x) =>
        (this.isConciergeEvent && x?.type === EventsTypes.PremiumServices) ||
        (this.isLifestyleEvent && x?.type === EventsTypes.LifestylePrograms)
      );
      return this.mapEventsToStringDates(this.draftEvents)
    },
    mapEventsToStringDates(events) {
      return events.map((e) => {
        return moment(e.start.seconds * 1000).format('YYYY-MM-DD')
      })
    },
    sortDates(dates) {
      dates.sort((a, b) => {
        const momentA = moment(a);
        const momentB = moment(b);
        return momentA.diff(momentB);
      });
      return dates;
    },
    close() {
      this.draftEventsDates = []
      this.dates = null
      this.loading = false
      this.open = false
    },
    onChangeEvents() {
      const table = this.$refs.datePicker.$refs.table;
      this.handleMonthChange(table.tableDate);
    },
    getEventColor(date) {
      const eventsForDate = this.draftEvents.filter(event => {
        const eventDate = moment(event.start.seconds * 1000).format("YYYY-MM-DD");
        if(eventDate === date) {
          return event;
        }
      });

      return eventsForDate.map(event => {
        return event.type === EventsTypes.PremiumServices ? 'green' : 'primary';
      });
    }
  }
}
</script>

<style scoped></style>
